import { Outlet } from "react-router-dom";
import { PlatformAuthProvider } from "../context/PlatformAuthContext";

export function PlatformAuthRoot() {
  return <PlatformAuthProvider><Outlet/></PlatformAuthProvider>;
}
